import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";

import "./GrantCapture.css";
import {Table} from "../../../common/table/Table";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {retrieveAllStaffMembers} from "../../../../services/StaffMemberService";
import {createGrant, updateGrant} from "../../../../services/GrantService";
import {GrantCaptureModal} from "./grant-capture-modal/GrantCaptureModal";
import {sortPersonList} from "../../../../util/PersonUtil";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";

export const GrantCapture = ({context, navigateTo, navigateBack, setSpinnerText, showToaster}) => {
    ReactModal.setAppElement('#root');

    const [externalReference, setExternalReference] = useState(null);
    const [grantName, setGrantName] = useState(null);
    const [grantResourceList, setGrantResourceList] = useState([]);
    const [staffMemberList, setStaffMemberList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [active, setActive] = useState(true);

    useEffect(() => {
        if (context.selectedGrant) {
            setExternalReference(context.selectedGrant.externalReference);
            setGrantName(context.selectedGrant.name);
            setActive(context.selectedGrant.active);
            const mappedGrantResourceVOs = context.selectedGrant.grantResourceVOs.map((grantResource) => {
                return {
                    ...grantResource,
                };
            });
            setGrantResourceList(mappedGrantResourceVOs);
        }
        const fetchSystemUsers = async () => {
            setSpinnerText("Retrieving Staff Members");
            const [data] = await retrieveAllStaffMembers(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const staffMembers = data.systemUserVOList.map((staffMember) => {
                        return {
                            ...staffMember,
                            isSelected: false,
                        }
                    });
                    sortPersonList(staffMembers);
                    setStaffMemberList(staffMembers);
                }
            }
            setSpinnerText(null);
        }
        fetchSystemUsers();
    }, []);


    const handleManageStaffClick = () => {
        const copyOfStaffMemberList = JSON.parse(JSON.stringify(staffMemberList));

        grantResourceList.forEach((grantResource) => {
            copyOfStaffMemberList.forEach((staffMember) => {
                if (staffMember.externalReference === grantResource.systemUserExternalReference) {
                    staffMember.isSelected = true;
                }
            });
        });

        setStaffMemberList(copyOfStaffMemberList);
        setShowModal(true);
    }

    const handleUpdateGrantResourcesClick = () => {
        const copyOfStaffMemberList = JSON.parse(JSON.stringify(staffMemberList));
        const selectedStaffMembers = copyOfStaffMemberList.filter((staffMember) => staffMember.isSelected);
        const mappedGrantResources = selectedStaffMembers.map((staffMember) => {
            return {
                externalReference,
                systemUserExternalReference: staffMember.externalReference,
                firstName: staffMember.firstName,
                lastName: staffMember.lastName,
                organisation: staffMember.organisation,
            }
        });
        setGrantResourceList(mappedGrantResources);
        setShowModal(false);
    }

    const handleAddOrUpdateGrantClick = async () => {
        const grantToBeSaved = {
            externalReference,
            name: grantName,
            grantResourceVOs: grantResourceList,
            active,
        }
        if (null === externalReference) {
            setSpinnerText("Creating Grant");
            const response = await createGrant(context.username, grantToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Grant");
            const response = await updateGrant(context.username, grantToBeSaved);
            handleResponse(response);
        }
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("grantTable");
            } else {
                showToaster(data);
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    return (
        <div className="grant-capture-container">
            <div className="grant-capture-input-container">
                <label>Grant Name:</label>
                <div className="grant-capture-select-container">
                    <input className="text-input" onChange={({target}) => {
                        setGrantName(target.value)
                    }} defaultValue={grantName}/>
                </div>
            </div>
            <div style={{width: 380, paddingTop: 10}}>
                <LeftLabelToggle labelText="Active: " active={active} setActive={setActive}/>
            </div>
            <div className="grant-capture-table-container">
                <Table tableData={grantResourceList}
                       buttonText="Manage Staff"
                       onButtonClick={handleManageStaffClick}
                       hiddenColumns={["externalReference", "systemUserExternalReference"]}
                       noResultsMessage={"No Staff Members Selected"}
                />
            </div>
            <div className="grant-capture-button-container">
                <StandardButton text={externalReference ? "Update Grant" : "Add Grant"}
                                onClick={handleAddOrUpdateGrantClick} disabled={!grantName}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>

            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <GrantCaptureModal staffMemberList={staffMemberList}
                                   setStaffMemberList={setStaffMemberList}
                                   onUpdateClick={handleUpdateGrantResourcesClick}
                />
            </ReactModal>
        </div>
    );
}
